/**
 * Component to handle user bulk upload
 */
import * as React from 'react';
import { Card, Breadcrumb, Table, Checkbox, Row, Button, message } from 'antd';
import CSVReader from 'react-csv-reader';
import dataservice from '../../service/data.service';
import '../../css/ProfileBulkUpload.scss';
import { VIEWSTATE } from '../common/constants';
import { staticProperties, STATICKEYS }  from '../common/staticProperties';
import LocalStorage from '../../service/localstorage';
import strings from '../../eyeguide-localization/user/string.user.upload';
import { CustomSorter } from '../Sorter';

const storage = new LocalStorage();
const SAMPLEFILE = require('../../sample/samplefile_user.csv');
const ERRORMSG = 'Invalid';
// const REQUIREDKEYS = [
//     'index',
//     'firstname',
//     'lastname',
//     'email',
//     'phone',
//     'role',
//     'org' ,
// ];
const CSVIMAGE = require('../../sample/user_sample.JPG');
const EXCELIMAGE = require('../../sample/user_sample_excel.JPG');

interface IUserBulkUploadProps {
    match: any;
    location: any;
}

interface IUserBulkUploadState {
    rosterName: string;
    columns: Array<any>;
    columnData: Array<any>;
    loading: boolean;
    isHeader: boolean;
    pagination: any;
    isError: boolean;
    infoColumns: Array<any>;
    infoData: Array<any>;
    showInfo: boolean;
    successCount: number;
    btnDisable: boolean;
    clearBtnDisable: boolean;
}

export default class UserBulkUpload 
            extends React.Component<IUserBulkUploadProps, IUserBulkUploadState> {

    constructor(props: IUserBulkUploadProps) {
        super(props);
        this.state = {
            rosterName: '',
            columns: [],
            columnData: [],
            loading: false,
            isHeader: false,
            pagination: {},
            isError: false,
            infoColumns: this.getInfoColumns(),
            infoData: this.getInfoData(),
            showInfo: true,
            successCount: 0,
            btnDisable: false,
            clearBtnDisable: false
        };
        this.handleFileLoad = this.handleFileLoad.bind(this);
        this.uploadUsers = this.uploadUsers.bind(this);
    }

    componentDidMount() {
        staticProperties.set(STATICKEYS.selectedKey, VIEWSTATE.USER);
        staticProperties.set(STATICKEYS.selectedRoster, '');
    }

    render() {
        return(
            <div className="ProfileBulkUpload"> 
                <Card>
                    <Breadcrumb>
                        <Breadcrumb.Item><a href="/dashboard">{strings.lsHomeTxt}</a></Breadcrumb.Item>
                        <Breadcrumb.Item><a href="/user">{strings.lsUsersTxt}</a></Breadcrumb.Item>
                        <Breadcrumb.Item>{strings.lsUploadUsrTxt}</Breadcrumb.Item>
                    </Breadcrumb>
                    <br/>
                    <h3> {strings.lsUploadUsrTxt} </h3>
                </Card>
                <Card bordered={false} style={{ margin: '24px 16px' }}> 

                    <CSVReader
                        cssClass="csv-input"
                        label={strings.lsSelectCSVTxt}
                        onFileLoaded={this.handleFileLoad}
                        onError={this.fileUploadError}
                    />
                    <Checkbox 
                        className="headerCheckbox" 
                        onChange={(val) => this.setState({isHeader: val.target.checked})}
                        checked={this.state.isHeader}
                    >
                        {strings.lsRowHdrTxt} 
                    </Checkbox>
                    <Row>
                        <Button 
                            type="primary" 
                            onClick={() => this.clearForm()}
                            disabled={this.state.clearBtnDisable}
                        > 
                            {strings.lsClearTxt}
                        </Button>
                    </Row>
                    {this.state.showInfo ? 
                    <div className="infoText"> {strings.lsRowInfoTxt}
                           <b> {strings.lsRowColsTxt} </b>
                        <Table
                            className="infoTable"
                            columns={this.state.infoColumns}
                            dataSource={this.state.infoData}
                            bordered={false}
                            pagination={false}
                            
                        />
                        <div> {strings.lsUploadInfoTxt} 
                        </div>
                        <div className="divSampleFile"> 
                            {strings.formatString(strings.lsUploadInfoTxt2, 
                                                  <a href={SAMPLEFILE}> {strings.lsHereTxt} </a>)}
                        </div>
                        <div>
                            {strings.lsUploadInfoTxt3}
                        </div>
                        <div> <img src={CSVIMAGE}/> </div>
                        <div>{strings.lsUploadInfoTxt4}</div>
                        <div><img src={EXCELIMAGE}/></div>
                    </div>
                    :
                    this.state.isError ? 
                    <div> 
                       <span>{this.state.successCount + ' ' + strings.lsUsrInfoTxt} </span>
                        <Table   
                            className="dataTable"              
                            columns={this.state.columns} 
                            dataSource={this.state.columnData} 
                            loading={this.state.loading}
                            rowClassName={(record, index) => 'rows'}
                            pagination={this.state.pagination}
                            rowKey={record => record.index}
                            bordered={true}
                        />         
                    </div>   :
                    <div>
                        <Row> 
                        {this.state.columnData.length === 0 ? '' :
                            <Button 
                                icon="upload"
                                className="downloadBtn"
                                type="primary" 
                                onClick={this.uploadUsers}
                                disabled={this.state.btnDisable}
                            > 
                                {strings.lsUploadTxt}
                            </Button> }
                        </Row> 
                        <Table   
                            className="dataTable"              
                            columns={this.state.columns} 
                            dataSource={this.state.columnData} 
                            loading={this.state.loading}
                            rowClassName={(record, index) => 'rows'}
                            pagination={this.state.pagination}
                            rowKey={record => record.index}
                            bordered={true}
                        />    
                    </div>
                    }
                </Card>
            </div>
        );
    }

    /**
     * Displays and sets the data fetched from csv uploaded
     * @param data Data fetched from csv as array to upload
     */
    private handleFileLoad(data: any) {
        console.log('handleFileLoad', data);
        this.setState({
            columnData: [],
            showInfo: false
        });
        console.log(this.state.columnData);
        let columnData = this.buildData(data);
        console.log(columnData);
        // let errorRows: any = [];
        // errorRows = this.validateData(columnData);
        // console.log('errorRows', errorRows);
        let columns = this.buildColumns();
        const pagination = { ...this.state.pagination };
        // pagination.total = errorRows.length > 0 ? errorRows.length : columnData.length;
        pagination.total = columnData.length;
        pagination.pageSize = 20 ;
        pagination.pageSizeOptions = ['20', '50', '75', '100'];
        pagination.showSizeChanger = true ;  
        pagination.showTotal = function (total: any) {
            return strings.formatString(strings.lsTotalUsrsTxt, total);
        };
        this.setState({
            columns,
            // columnData: errorRows.length > 0 ? errorRows : columnData ,
            // isError: errorRows.length > 0 ? true : false,
            columnData: columnData,
            pagination
        });
        
    }

    private fileUploadError() {
        console.log('fileUploadError');
    }

    /**
     * This function returns the column setting for use with the Table component
     * @param isError True, If uploaded data does not pass validation
     */
    private buildColumns(isError: boolean = false) {
        let columns: any = [
          { 
            title: strings.lsRowNoTxt,
            dataIndex: 'index',
            sorter: (a: any, b: any) => 
                parseInt(a.index, 10) < parseInt(b.index, 10) ? -1 : 1
            ,
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: strings.lsUsrNameTxt,
            dataIndex: 'username',
            sorter: (a: any, b: any) => a.username.localeCompare(b.username),
            className: 'rows',
            render: (text: any) => 
                text === ERRORMSG ? (
                
                <div
                    style={{color: 'red'}}
                >
                {text}
                </div>) : text,
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: strings.lsFNameTxt,
            dataIndex: 'firstname',
            sorter: (a: any, b: any) => a.firstname.localeCompare(b.firstname),
            className: 'rows',
            render: (text: any) => 
            text === ERRORMSG ? (
            
            <div
                className={'clipped'}
                style={{color: 'red', width: '150px'}}
                title={text}
            >
            {text}
            </div>) : (
                <div
                    className={'clipped'}
                    style={{width: '150px'}}
                    title={text}
                >
            {text}
                </div>)
            , onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: strings.lsLNameTxt,
            dataIndex: 'lastname',
            sorter: (a: any, b: any) => a.lastname.localeCompare(b.lastname),
            className: 'rows',
            render: (text: any) => 
            text === ERRORMSG ? (
            
            <div
                className={'clipped'}
                style={{width: '150px', color: 'red'}}
                title={text}
            >
            {text}
            </div>) : (
                <div
                    className={'clipped'}
                    style={{width: '150px'}}
                    title={text}
                >
            {text}
                </div>),
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          } ,
          {
            title: strings.lsEmailTxt,
            dataIndex: 'email',
            sorter: (a: any, b: any) => a.email.localeCompare(b.email),
            className: 'rows',
            render: (text: any) => 
            text === ERRORMSG ? (
            
            <div
                className={'clipped'}
                style={{color: 'red', width: '150px'}}
                title={text}
            >
            {text}
            </div>) : (
                <div
                    className={'clipped'}
                    style={{width: '150px'}}
                    title={text}
                >
            {text}
                </div>),
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          } ,
          {
            title: strings.lsMobilePhoneTxt,
            dataIndex: 'phone',
            sorter: (a: any, b: any) => a.phone.localeCompare(b.phone),
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }            
          } ,
          {
            title: strings.lsRoleTxt,
            dataIndex: 'role',
            sorter: (a: any, b: any) => a.role.localeCompare(b.role),
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: strings.lsOrgTxt,
            dataIndex: 'org',
            sorter: (a: any, b: any) => a.org.localeCompare(b.org),
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: strings.lsTestDeletionTxt,
            dataIndex: 'candeletetest',
            sorter: (a: any, b: any) => a.org.localeCompare(b.org),
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          }
        ];
        if ( isError ) {
            columns.push( {
              title: strings.lsErrTxt,
              dataIndex: 'error',
              className: 'errorCol',
              render: (text: any) => 
                     
                text.map((e: any) => 
                    (
                    <div>
                    {e}
                </div> ))
                            });
        }
        return columns;
    }

    /**
     * This function builds the data required by the Table component to display the users
     * @param users User array containing the users to be dispalyed
     */
    private buildData(users: Array<any>) {
        let columnData: Array<any> = [];
        if (users !== null) {
            let i = 0;
            users.forEach( (element: any) => {
                if (i === 0 && this.state.isHeader) {
                    // skip header
                } else {
                let data = {
                    index: i + 1,
                    username: element[0] !== undefined ? element[0] : '',
                    firstname: element[1] !== undefined ? element[1] : '',
                    lastname: element[2] !== undefined ? element[2] : '',
                    email: element[3] !== undefined ? element[3] : '',
                    phone: element[4] !== undefined ? element[4] : '',
                    role: element[5] !== undefined ? element [5] : '',
                    org: element[6] !== undefined ? element[6] : '',
                    candeletetest: element[7] !== undefined ? element[7] : 1,
                    error: ''
                };
                columnData.push(data);
                }
                i += 1;
            }); 
        }
        return columnData;
    }

    // private validateData(data: any) {
    //     let errorRows: any = [];
    //     errorRows = data.filter((e: any) => { // get the error rows
    //         let isError: boolean = false;

    //         for (let key of Object.keys(e)) {
            //     if ( REQUIREDKEYS.indexOf(key) > -1 ) {
            //         if (e[key] !== undefined && e[key]  !== null && e[key].toString().trim() === '') {
            //             isError = true;
    //                     e[key] = ERRORMSG;
            //         } else if (e[key]  === undefined || e[key]  === null ) {
            //             isError = true;
    //                     e[key] = ERRORMSG;
    //                 } 
    //             }
    //         }
    //         return isError;
            // });
    //     return errorRows;
    // }

    /**
     * This function is called when Upload button is clicked.
     * Data is sent to server for uploading.
     */
    private async uploadUsers() {
        this.setState({ 
            btnDisable : true,
            clearBtnDisable: true 
        });
        let users: any = this.getUserObj();
        let blb: any = new Blob([JSON.stringify(users)], { type: 'text/plain' });
        // let file = new File([blb], 'text.txt');
        let file = blb;
        // file.name = 'test.txt';
        console.log('file', file);
        let ser = new dataservice();
        let resp = await ser.uploadUsers(file, storage.getSelectedOrgPrimary());
        this.setState({ 
            btnDisable: false,
            clearBtnDisable: false 
        });
        console.log('upload Users response', resp);
        if (resp !== null && resp.length > 0 && resp[0].status === 0) {
            message.success(this.state.columnData.length + ' ' + strings.lsUsrUploadSucessTxt);
            this.clearForm();
        } else {
            this.displayErrors(resp);
        }
    }

    /**
     * This function is called if validation of data fails from server side
     * It handles display of errors in data on UI.
     * @param resp Server response
     */
    private displayErrors(resp: any) {
        let data: any = [];
        console.log('data', this.state.columnData);
        this.state.columnData.forEach((e: any, dataIndex: number) => {
            console.log('e', e);
            for (let i = 0; i < resp.length; i++) {
                if (resp[i].index === e.index) {
                    console.log('matched', e.index);
                    e.error = resp[i].message; 
                    data.push(e);
                    console.log('data index', data);
                    break;
                }                    
            }
        });
        console.log('data', data);
        console.log('pagination', this.state.pagination);
        let sucessUserCount: number = this.state.columnData.length - data.length ;
        let pagination: any = this.state.pagination;
        pagination.total = data.length;
        this.setState({
            columnData: data,
            columns: this.buildColumns(true),
            isError: true,
            pagination,
            successCount: sucessUserCount
        });
        
        message.error(sucessUserCount + ' ' + strings.lsUsrUploadSucessTxt);
    }

    /**
     * Returns user object in json format
     * to be sent to server for processing
     */
    private getUserObj(): any {
        let Users: any = [];
        this.state.columnData.forEach((e: any) => {
            let inputUser: any = {
                'index': e.index !== null ? e.index : '',
                'username': e.username !== null ? e.username.trim() : '',
                'firstname': e.firstname !== null ? e.firstname.trim() : '',
                'lastname': e.lastname !== null ? e.lastname.trim() : '',
                'email': e.email !== null ? e.email.trim() : '',
                'phone': e.phone !== null && e.phone !== undefined
                                     ? e.phone.trim() : '',
                'role': e.role !== null && e.role !== undefined 
                                     ? e.role.trim() : '',
                'organizations': e.org !== null && e.org !== undefined
                                     ? e.org.trim() : '',
                'candeletetest': e.candeletetest !== null && e.candeletetest !== undefined
                ? e.candeletetest : 1
            };  
            Users.push(inputUser);
        });
        console.log('Users', Users);
        return Users;
    }

    /**
     * Clears the page
     */
    private clearForm() {
        let elm: any = document.getElementsByClassName('csv-input')[1];
        elm.value = '';
        let pagination = this.state.pagination;
        pagination.total = 0;
        this.setState({
            rosterName: '',
            columns: [],
            columnData: [],
            loading: false,
            isHeader: false,
            pagination: pagination,
            isError: false,
            showInfo: true,
            successCount: 0
        });
    }

    /**
     * Sets and returns the columns for the information table.
     */
    private getInfoColumns() {
        let columns = [
            {
              title: strings.lsColTxt,
              dataIndex: 'column',
              className: 'rows'
            },
            {
              title: strings.lsDescTxt,
              dataIndex: 'description',
              className: 'rows'
            },
            {
              title: strings.lsReqTxt,
              dataIndex: 'required',
              className: 'rows'
            }];
        return columns;
    }

    /**
     * Sets and returns the data for Information table.
     */
    private getInfoData() {
        let columnData: Array<any> = [];
        columnData = [{
            column: strings.lsUsrNameTxt,
            description: strings.lsUsrNameDescTxt,
            required: 'Yes',
        }, {
            column: strings.lsFNameTxt,
            description: strings.lsFNameDescTxt,
            required: 'Yes',
        }, {
            column: strings.lsLNameTxt,
            description: strings.lsLNameDescTxt,
            required: 'Yes',
        }, {
            column: strings.lsEmailTxt,
            description: strings.lsEmailDescTxt,
            required: 'Yes',
        }, {
            column: strings.lsMobilePhoneTxt,
            description: strings.lsMobilePhoneDescTxt,
            required: 'Yes',
        }, {
            column: strings.lsRoleTxt,
            description: strings.lsRoleDescTxt,
            required: 'Yes',
        }, {
            column: strings.lsOrgTxt,
            description: strings.lsOrgDescTxt,
            required: 'Yes',
        }, {
            column: strings.lsTestDeletionTxt,
            description: strings.lsTestDeletionDescTxt,
            required: 'No',
        }
        ];
        console.log('columnData', columnData);
        return columnData;
    }

    // private formatErrorMsgs(errorMsg: string) {
    //     let msgs: any = errorMsg.split(',');
    //     console.log(msgs);
    //     return msgs;
    // }
}


// WEBPACK FOOTER //
// ./src/components/user/UserBulkUpload.tsx